module.exports = __webpack_public_path__ + "img/KinokoTable72.4d7dc1f6.jpg";